import React, { useState, useEffect } from "react";

const ToggleBtn = ({ onToggle, serviceName, initialIsOn, serviceTitle }) => {
    const [isOn, setIsOn] = useState(initialIsOn);

    // Update the isOn state if initialIsOn changes
    useEffect(() => {
        setIsOn(initialIsOn);
    }, [initialIsOn]);

    const handleToggle = () => {
        setIsOn(!isOn);
        if (onToggle) {
            onToggle(serviceName, !isOn, serviceTitle);
        }
    };

    return (
        <div>
            <div
                className={`w-[44px] h-[24px] rounded-full relative cursor-pointer transition-colors duration-300 ease-in-out ${
                    isOn ? "bg-[#ff7374]" : "bg-[#A6ABB3]"
                }`}
                onClick={handleToggle}
            >
                <div
                    className={`w-[20px] h-[20px] bg-white absolute top-[2px] rounded-full transform transition-transform duration-300 ease-in-out ${
                        isOn ? "translate-x-[22px]" : "translate-x-[2px]"
                    }`}
                />
            </div>
        </div>
    );
};

export default ToggleBtn;
